module.exports = __webpack_public_path__ + "img/middle_16.dfda4425.png";